import { apiClient, type CreateShipmentOrderDto } from '@/libs/api'

export type CreateShipmentOrderRequest = {
  tenantKey: string
  dto: CreateShipmentOrderDto
}

export const createShipmentOrder = async ({
  tenantKey,
  dto
}: CreateShipmentOrderRequest) => {
  const { data, errors } = await apiClient
    ._tenant(tenantKey)
    .shipment_orders.$post({ body: dto })
  return { data, errors }
}
